class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.loading = false;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
      },
      { rootMargin: '0px 0px 800px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async loadMore() {
    if (this.loading) return;

    const nextUrl = this.getAttribute('data-next-url');
    if (!nextUrl) {
      this.remove();
      return;
    }

    this.loading = true;
    this.classList.add('infinite-scroll--loading');

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error(`Failed to load ${nextUrl} (${response.status})`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const newItems = doc.querySelectorAll('#product-grid > *');
      document.getElementById('product-grid')?.append(...newItems);

      const newNextUrl = doc.querySelector('infinite-scroll')?.getAttribute('data-next-url');
      if (newNextUrl) {
        this.setAttribute('data-next-url', newNextUrl);
      } else {
        this.observer.disconnect();
        this.remove();
      }
    } catch (error) {
      console.error('[infinite-scroll]', error);
      // Stop auto-loading and fall back to the visible "next page" link
      this.observer.disconnect();
      this.classList.add('infinite-scroll--error');
    } finally {
      this.loading = false;
      this.classList.remove('infinite-scroll--loading');
    }
  }
}

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', InfiniteScroll);
}
